module.exports = __webpack_public_path__ + "img/1.555ea0e4.jpg";